module.exports = __webpack_public_path__ + "img/pic_default.5d49734c.png";